import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import GetQuote from '../GetQuote';

const Header = () => {
    const location = useLocation();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const isActiveLink = (path: string) => {
        return location.pathname === path;
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    return (
        <header>
            <div className="container">
                <div className="header-content">
                    <div className="logo">
                        <Link 
                            to="/" 
                            onClick={closeMobileMenu}
                            style={{ 
                                textDecoration: 'none', 
                                color: 'inherit', 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '10px' 
                            }}
                        >
                            <img
                                src="/logo192.jpg"
                                alt="Maa Saryu Agency Logo"
                                className="logo-img"
                                style={{
                                    height: '48px',
                                    width: '48px',
                                    objectFit: 'contain',
                                    borderRadius: '50%',
                                    border: '2px solid #eee',
                                    background: '#fff'
                                }}
                            />
                            <h1 className="logo-text">Maa Saryu Agency</h1>
                        </Link>
                    </div>
                    
                    {/* Mobile Menu Toggle */}
                    <button 
                        className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
                        onClick={toggleMobileMenu}
                        aria-label="Toggle navigation menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    {/* Navigation Menu */}
                    <nav className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
                        <ul>
                            <li>
                                <Link 
                                    to="/" 
                                    onClick={closeMobileMenu}
                                    className={`nav-link ${isActiveLink('/') ? 'active' : ''}`}
                                >
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/products" 
                                    onClick={closeMobileMenu}
                                    className={`nav-link ${isActiveLink('/products') ? 'active' : ''}`}
                                >
                                    Products
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/gallery" 
                                    onClick={closeMobileMenu}
                                    className={`nav-link ${isActiveLink('/gallery') ? 'active' : ''}`}
                                >
                                    Gallery
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/about" 
                                    onClick={closeMobileMenu}
                                    className={`nav-link ${isActiveLink('/about') ? 'active' : ''}`}
                                >
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/contact" 
                                    onClick={closeMobileMenu}
                                    className={`nav-link ${isActiveLink('/contact') ? 'active' : ''}`}
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                        <div className="mobile-get-quote" onClick={closeMobileMenu}>
                            <GetQuote className="contact-btn">Get Quote</GetQuote>
                        </div>
                    </nav>

                    {/* Desktop Get Quote Button */}
                    <div className="desktop-get-quote">
                        <GetQuote className="contact-btn">Get Quote</GetQuote>
                    </div>
                </div>
            </div>
            
            {/* Mobile Menu Overlay */}
            {mobileMenuOpen && (
                <div 
                    className="mobile-menu-overlay" 
                    onClick={closeMobileMenu}
                ></div>
            )}
        </header>
    );
};

export default Header;